import loadable from '@loadable/component';
import { WithLazyHydration } from '../../WithLazyHydration';

const CarouselLoadable = loadable(() => import('./Carousel'), {
  resolveComponent: components => components.Carousel
});

export const Carousel = WithLazyHydration(CarouselLoadable, {
  name: 'Carousel'
});
